export default __webpack_public_path__ + "static/media/a6_postcard_landscape.6c26c350.png";